import {login, logout} from '@/api/authority/localUser'
import {getToken, getUserInfo, removeToken, removeUserInfo, setToken, setUserInfo} from '@/utils/localStorage'

const userinfo = await getUserInfo()
const state = {
    token: getToken(),
    username: userinfo.username,
    iconPath: userinfo.iconPath,
    roles: [],
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_USERNAME: (state, username) => {
        state.username = username
    },
    SET_ICON_PATH: (state, iconPath) => {
        state.iconPath = iconPath
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    }
}

const actions = {
    // user login
    login({commit, dispatch}, userInfo) {
        const {username, password} = userInfo
        return new Promise((resolve, reject) => {
            login({account: username.trim(), password: password}).then(response => {
                let {token, menus, userInfo} = response.data
                //状态
                commit('SET_USERNAME', userInfo.name)
                commit('SET_ICON_PATH', userInfo.iconPath)
                commit('SET_TOKEN', token)
                //用户信息
                setToken(token)
                setUserInfo(userInfo)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },


    // user logout
    logout({commit, state, dispatch}) {
        return new Promise( (resolve, reject) => {
            logout(state.token).then( () => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                dispatch('tagsView/delAllViews', null, {root: true})
                dispatch('permission/setRoutes', [], {root: true})
                 removeToken()
                 removeUserInfo()
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },


}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
